


  import dep0 from "ember-cli-babel/-embroider-implicit-modules.js";
  import dep1 from "ember-element-helper/-embroider-implicit-modules.js";
  import dep2 from "@ember/render-modifiers/-embroider-implicit-modules.js";
  import dep3 from "ember-auto-import/-embroider-implicit-modules.js";
  import dep4 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep5 from "ember-cli-htmlbars/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
  {
  }
);
